export enum PhotoPodRule {
  ONLY_AT_THE_DROP_LOCATION  = 'ONLY_AT_THE_DROP_LOCATION',
  PICK_LOCATION_FOR_COLLECTION  = 'PICK_LOCATION_FOR_COLLECTION',
}
